exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-add-category[data-v-7ce9fdb6]{padding:12px;text-align:center;border:1px solid #ff5722;color:#ff5722;border-radius:4px;font-size:.9rem}.btn-add-category[data-v-7ce9fdb6]:hover{color:#fff;background-color:#ff5722}", ""]);

// exports
